import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
const Dropdown = ({ options, onChange, value, placeholder }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [selectedOption, setSelectedOption] = useState(options.find((option) => option.value === value));
	const menuRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (menuRef.current && !menuRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		if (isOpen) {
			document.addEventListener('mousedown', handleClickOutside);
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isOpen]);

	return (
		<div className='relative inline-block text-left'>
			<div>
				<button
					type='button'
					className='inline-flex cursor-pointer w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-medium text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50'
					id='menu-button'
					aria-expanded='true'
					aria-haspopup='true'
					onClick={() => setIsOpen(!isOpen)}
				>
					{selectedOption ? (
						<div className='flex items-center gap-2'>
							{selectedOption.icon}
							{selectedOption.label}
						</div>
					) : (
						placeholder
					)}
					<svg
						className='-mr-1 size-5 text-gray-400'
						viewBox='0 0 20 20'
						fill='currentColor'
						aria-hidden='true'
						data-slot='icon'
					>
						<path
							fillRule='evenodd'
							d='M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z'
							clipRule='evenodd'
						/>
					</svg>
				</button>
			</div>

			<div
				ref={menuRef}
				className='absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white ring-1 shadow-lg ring-black/5 focus:outline-hidden'
				role='menu'
				aria-orientation='vertical'
				aria-labelledby='menu-button'
				tabIndex='-1'
				style={{ display: isOpen ? 'block' : 'none' }}
			>
				<div className='py-1' role='none'>
					{options.map((option, index) => (
						<div
							className='block px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100'
							key={index}
							onClick={() => {
								setSelectedOption(option);
								onChange(option.value);
								setIsOpen(false);
							}}
						>
							<div className='flex items-center gap-2'>
								{option.icon}
								{option.label}
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

Dropdown.propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
			icon: PropTypes.element,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		}),
	),
	onChange: PropTypes.func,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	placeholder: PropTypes.string,
	label: PropTypes.string,
	disabled: PropTypes.bool,
};

export default Dropdown;
